// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Layout_wrapper__zPRDd","section":"Layout_section__t5S_7"};